type FontSrc =
  | string
  | {
      path: string;
      weight?: string;
      style?: string;
    };

type LocalFontOptions = {
  src: FontSrc | FontSrc[];
  variable?: string;
  preload?: boolean;
};

type LocalFontResult = {
  className: string;
  style: {
    fontFamily: string;
  };
  variable: string | undefined;
};

const styleSheet = document.createElement('style');
document.head.appendChild(styleSheet);

const createFontFaceRule = (src: FontSrc, fontFamily: string) => {
  const { path, weight, style } = typeof src === 'string' ? { path: src } : src;
  const translatedPath = `/fonts/${path.replace(/^\.\//, '')}`;

  return `@font-face {
    font-family: '${fontFamily}';
    src: url('${translatedPath}');
    ${style ? `font-style: ${style};` : ''}
    ${weight ? `font-weight: ${weight};` : ''}
  }`;
};

function localFont(options: LocalFontOptions): LocalFontResult {
  let fontFamilyName = 'CustomFont';

  if (typeof options.src === 'string') {
    fontFamilyName = `CustomFont-${options.src.split('/').pop()?.split('.')[0]}`;
  } else if (Array.isArray(options.src) && options.src.length > 0 && typeof options.src[0] !== 'string') {
    fontFamilyName = `CustomFont-${options.src[0].path.split('/').pop()?.split('.')[0]}`;
  }

  const srcArray = Array.isArray(options.src) ? options.src : [options.src];
  srcArray.forEach(font => {
    const fontFaceRule = createFontFaceRule(font, fontFamilyName);
    if (styleSheet.sheet) {
      styleSheet.sheet.insertRule(fontFaceRule, styleSheet.sheet.cssRules.length);
    }
  });

  const result: LocalFontResult = {
    className: `custom-font-${Date.now()}`,
    style: {
      fontFamily: fontFamilyName
    },
    variable: options.variable || undefined
  };

  if (options.variable) {
    const varRule = `:root { ${options.variable}: ${fontFamilyName}; }`;
    if (styleSheet.sheet) {
      styleSheet.sheet.insertRule(varRule, styleSheet.sheet.cssRules.length);
    }
  }

  return result;
}

export default localFont;
export type { LocalFontOptions, LocalFontResult };
